// src/utils/TextoUtils.js
export const normalizarTextoComparacao = (valor) => String(valor ?? '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .trim()
  .toLocaleLowerCase('pt-BR');

// Copia um texto para a área de transferência; usa fallback quando a Clipboard API não está disponível (ex.: http na rede local).
export const copiarTexto = async (texto) => {
  const valor = String(texto ?? '');
  if (!valor) return false;

  if (navigator?.clipboard?.writeText && window.isSecureContext !== false) {
    try {
      await navigator.clipboard.writeText(valor);
      return true;
    } catch (erro) {
      // segue para o fallback abaixo
    }
  }

  const campo = document.createElement('textarea');
  campo.value = valor;
  campo.setAttribute('readonly', '');
  campo.style.position = 'fixed';
  campo.style.opacity = '0';
  document.body.appendChild(campo);
  campo.select();
  try {
    return document.execCommand('copy');
  } catch (erro) {
    return false;
  } finally {
    document.body.removeChild(campo);
  }
};
